export const CONFIG = {
    client_name: "eurobaustoff",
    client_display_name: "Eurobaustoff",
    modal_confirm_button_label: "übernehmen",
    country: 'de',
    base_asset_url: `https://esr.fe-bis.de/de/eurobaustoff/`,
    plz_validation: (plz: string) => plz.length == 5,
    plz_default: "12345",
    foerderung: true,
    development_mode: false,
}
